class footerAccordion extends HTMLElement {
  constructor() {
    super();

    if (this.classList.contains('admin-panel--no-js')) return;

    this.toggleContent = '.footer__accordion__content';
    this.boxes = this.querySelectorAll('.footer__accordion__heading');

    if (!this.boxes.length) return;

    // 🔥 Mark first accordion
    this.firstBox = this.boxes[0];

    this.bindEvents();
    this.openFirstAccordion();
    this.resizeHandler();

    window.addEventListener("resize", this.resizeHandler.bind(this), false);
  }

  bindEvents() {
    const _this = this;

    this.boxes.forEach((box, index) => {
      box.addEventListener('click', event => {
        event.preventDefault();

        if (window.innerWidth > 576) return false;

        // 🚫 Never allow first accordion to toggle
        if (box === _this.firstBox) return false;

        const opened = _this.querySelectorAll('.footer__accordion__heading[open]');

        // Toggle clicked accordion
        if (box.hasAttribute('open')) {
          box.classList.remove('footer__accordion-opening');
          box.removeAttribute('open');
        } else {
          box.setAttribute('open', '');
          setTimeout(() => {
            _this.resizeHandler();
            box.classList.add('footer__accordion-opening');
          }, 0);
        }

        // ❗ Close others EXCEPT first
        opened.forEach(child => {
          if (child !== box && child !== _this.firstBox) {
            child.classList.remove('footer__accordion-opening');
            setTimeout(() => {
              child.removeAttribute('open');
            }, 300);
          }
        });
      });
    });
  }

  // 🔥 Force first accordion always open
  openFirstAccordion() {
    if (!this.firstBox) return;

    this.firstBox.setAttribute('open', '');
    this.firstBox.classList.add('footer__accordion-opening');

    setTimeout(() => {
      this.resizeHandler();
    }, 0);
  }

  resizeHandler() {
    const boxes = this.querySelectorAll('[open]+' + this.toggleContent);
    boxes.forEach(box => {
      box.style.setProperty('--scroll-height', (box.scrollHeight + 1) + 'px');
    });
  }
}

customElements.define('footer-accordion', footerAccordion);
